import React from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { Form, Input, Header, Segment, Button, Icon, Popup, Transition, Loader } from 'semantic-ui-react';

import VehicleTable from './Vehicles/VehicleTable';
import VehicleFilter from './Vehicles/VehicleFilter';
import VehicleDetails from './Vehicles/VehicleDetails';
import PaginationSegment from './util/PaginationSegment';
import ResultsPerPageDropdown from './util/ResultsPerPageDropdown'
import { fetchManufacturers, fetchStatuses, fetchTypes, fetchOrganizationalUnits, fetchFuelType } from './Lookups/util';
import { IconHeader, FiltersOnStyle } from './util/css';
import { getTotalNumberOfPages, checkOrganizationalUnitsPrivilege, checkFaculty, checkWritePrivilege, formatListForDropdownOptions, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE } from './util/util';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class Vehicles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnits: [],
            organizationalUnitId: null,
            activeRole: null,

            vehicles: [],
            filteredVehicles: [],

            lookups: {
                manufacturers: [],
                types: [],
                statuses: [],
                fuelTypes: [],
                organizationalUnits: []
            },

            // Form data
            manufacturer: null,
            type: null,
            status: null,
            model: '',
            licencePlate: '',
            chassisNumber: '',
            numberOfSeats: '',
            purchaseYear: '',
            productionYear: '',
            fuelType: null,
            vehicleId: null,
            optLock: null,

            // Component behaviour
            requestMode: null,
            loading: true,
            showFiltersOnButton: false,
            showFilterMode: false,

            // For details
            details: false,
            vehicleObject: null,

            // For required fields
            organizationalUnitError: false,
            typeError: false,
            chassisNumberError: false,
            licencePlateError: false,

            // For pagination
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,

            // For sorting, default values
            fieldName: null,
            fieldProperty: null,
            direction: null,
        };

        this.sendVehicleRequest = this.sendVehicleRequest.bind(this);
        this.getVehicles = this.getVehicles.bind(this);
        this.updateVehicles = this.updateVehicles.bind(this);
        this.populateValues = this.populateValues.bind(this);
        this.resetValues = this.resetValues.bind(this);
        this.activateAddRequest = this.activateAddRequest.bind(this);
        this.activateEditRequest = this.activateEditRequest.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.activateFilter = this.activateFilter.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);

        this.fetchLookups = this.fetchLookups.bind(this);
        this.getUserData = this.getUserData.bind(this);

        this.fetchDataForRole = this.fetchDataForRole.bind(this);

        this.switchToDetails = this.switchToDetails.bind(this);
        this.switchToTable = this.switchToTable.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getFilteredVehicles = this.getFilteredVehicles.bind(this);
        this.handleResultsPerPageChange = this.handleResultsPerPageChange.bind(this);
        this.getSortedVehicles = this.getSortedVehicles.bind(this);

        this.handleLicencePlateChange = this.handleLicencePlateChange.bind(this);
    }

    componentWillMount() {
        this.getUserData();
    }

    getUserData() {
        axios.all([this.fetchActiveRole(), this.fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;

                this.fetchLookups(activeRole, organizationalUnitId);
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchLookups(activeRole, organizationalUnitId) {
        axios.all([fetchManufacturers(), fetchTypes(), fetchStatuses(), fetchFuelType()])
            .then(axios.spread((manufacturersRes, typesRes, statusesRes, fuelTypesRes, vehiclesRes) => {
                const manufacturers = formatListForDropdownOptions(manufacturersRes.data);
                const types = formatListForDropdownOptions(typesRes.data);
                const statuses = formatListForDropdownOptions(statusesRes.data);
                const fuelTypes = formatListForDropdownOptions(fuelTypesRes.data);

                const lookups = {
                    manufacturers,
                    types,
                    statuses,
                    fuelTypes,
                };

                this.fetchDataForRole(activeRole, organizationalUnitId, lookups);
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchDataForRole(activeRole, organizationalUnitId, lookups) {
        if (checkOrganizationalUnitsPrivilege(activeRole)) {
            axios.all([fetchOrganizationalUnits(), this.fetchAllVehicles()])
                .then(axios.spread((organizationalUnitsRes, vehiclesRes) => {
                    const organizationalUnits = formatListForDropdownOptions(organizationalUnitsRes.data);
                    const vehicles = vehiclesRes.data.responseList;

                    let totalPages = getTotalNumberOfPages(vehiclesRes.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
                    this.setState({
                        organizationalUnits,
                        vehicles,
                        loading: false,
                        totalPages,
                        lookups,
                        activeRole,
                        organizationalUnitId,
                    });
                }))
                .catch((err => {
                    this.setState({ error: true, loading: false });
                    console.log('Failed to fetch data.');
                }));
        } else if (checkFaculty(activeRole)) {
            this.fetchVehicles()
                .then((vehiclesRes) => {
                    const vehicles = vehiclesRes.data.responseList;

                    let totalPages = getTotalNumberOfPages(vehiclesRes.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
                    this.setState({
                        vehicles,
                        loading: false,
                        totalPages,
                        lookups,
                        activeRole,
                        organizationalUnitId,
                    });
                })
                .catch((err) => {
                    console.log('Failed to fetch data: ', err);
                    this.setState({ error: true, loading: false });
                });
        }
    }


    fetchActiveRole() {
        return axios.get('/user/type');
    }

    fetchUserOrganizationalUnit() {
        return axios.get('/user/organizational-unit');
    }

    fetchVehicles(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        return axios.post('/assets/vehicle/paginated/', { ...pagination });
    }

    fetchAllVehicles(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        return axios.post('/assets/vehicle/all/', { ...pagination });
    }

    getVehicles(page, resultsPerPage, sortingDTO = null) {
        const {
            activeRole, fieldName, fieldProperty, direction
        } = this.state;
        const pagination = {
            page,
            resultsPerPage,
            fieldName: sortingDTO ? sortingDTO.fieldName : fieldName,
            fieldProperty: sortingDTO ? sortingDTO.fieldProperty : fieldProperty,
            order: sortingDTO ? sortingDTO.direction === 'ascending' : direction ? direction === 'ascending' : null,
        };

        if (checkOrganizationalUnitsPrivilege(activeRole)) {
            axios.post('/assets/vehicle/all/', { ...pagination })
                .then(res => {
                    this.updateVehicles(page, resultsPerPage, res, sortingDTO);
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                    console.log('Greska!');
                });
        } else if (checkFaculty(activeRole)) {
            axios.post('/assets/vehicle/paginated/', { ...pagination })
                .then(res => {
                    this.updateVehicles(page, resultsPerPage, res, sortingDTO);
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                    console.log('Greska!');
                });
        }
    }

    getFilteredVehicles(page, resultsPerPage, sortingDTO = null) {
        const {
            fieldName, fieldProperty, direction
        } = this.state;
        const paginationDTO = {
            page,
            resultsPerPage,
            fieldName: sortingDTO ? sortingDTO.fieldName : fieldName,
            fieldProperty: sortingDTO ? sortingDTO.fieldProperty : fieldProperty,
            order: sortingDTO ? sortingDTO.direction === 'ascending' : direction ? direction === 'ascending' : null,
        };
        let { filterRequestData } = this.state;
        filterRequestData = { ...filterRequestData, paginationDTO };

        axios.post('/assets/vehicle/filter/', { ...filterRequestData })
            .then(res => {
                this.updateVehicles(page, resultsPerPage, res, sortingDTO, true);
            })
            .catch(err => {
                console.log('Failed to fetch filter results: ', err);
                toast('Došlo je do greške prilikom filtriranja!');
            });
    }

    getSortedVehicles(fieldName, fieldProperty = null) {
        const sortingDTO = {
            direction: (this.state.fieldName === fieldName ? (this.state.direction === 'ascending' ? 'descending' : 'ascending') : 'ascending'),
            fieldName,
            fieldProperty,
        };

        if (!this.state.showFiltersOnButton) {
            this.getVehicles(this.state.activePage - 1, this.state.resultsPerPage, sortingDTO);
        } else {
            this.getFilteredVehicles(this.state.activePage - 1, this.state.resultsPerPage, sortingDTO);
        }
    }

    updateVehicles(page, resultsPerPage, res, sortingDTO, filtersOn = false) {
        const vehicles = res.data.responseList;
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);

        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            vehicles: filtersOn ? [] : vehicles,
            filteredVehicles: filtersOn ? vehicles : [],
            totalPages,
            fieldName: sortingDTO ? sortingDTO.fieldName : prevState.fieldName,
            fieldProperty: sortingDTO ? sortingDTO.fieldProperty : prevState.fieldProperty,
            direction: sortingDTO ? (sortingDTO.fieldName === prevState.fieldName ? (prevState.direction === 'ascending' ? 'descending' : 'ascending') : 'ascending') : prevState.direction,
        }));
    }

    onFilterData(vehFilter) {
        const { activeRole, resultsPerPage } = this.state;
        let vehFilterRequest = {
            ...vehFilter,
            paginationDTO: {
                page: 0,
                resultsPerPage,
            },
        };

        // Making sure it is sending for the current logged in organizational unit
        if (checkFaculty(activeRole)) {
            vehFilterRequest = {
                ...vehFilterRequest,
                organizationalUnit: this.state.organizationalUnitId,
            };
        }

        axios.post('/assets/vehicle/filter/', { ...vehFilterRequest })
            .then(res => {
                const filterData = res.data.responseList;
                let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
                this.setState({
                    activePage: 1,
                    totalPages,
                    filteredVehicles: filterData,
                    vehicles: [],
                    showFiltersOnButton: true,
                    filterRequestData: vehFilterRequest,
                    showFilterMode: false,
                });
            })
            .catch(err => {
                console.log('Failed to fetch filter results: ', err);
                toast('Došlo je do greške prilikom filtriranja!');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filteredVehicles;
        }
        return this.state.vehicles;
    }

    sendVehicleRequest() {
        const {
            manufacturer,
            model,
            type,
            licencePlate,
            chassisNumber,
            numberOfSeats,
            purchaseYear,
            productionYear,
            fuelType,
            status,
            organizationalUnitId,
            vehicleId,
            optLock,
        } = this.state;

        if (organizationalUnitId === null || type === null || chassisNumber === '' || licencePlate === '' || chassisNumber === null || licencePlate === null) {
            this.setState({
                organizationalUnitError: organizationalUnitId === null,
                typeError: type === null,
                chassisNumberError: chassisNumber === '' || chassisNumber === null,
                licencePlateError: licencePlate === '' || licencePlate === null,
            });

            toast('Nisu sva potrebna polja unešena!');
            return;
        }

        const vehicleRequest = {
            organizationalUnit: organizationalUnitId ? { id: organizationalUnitId } : null,
            manufacturer: manufacturer ? { id: manufacturer } : null,
            model: model === '' ? null : model,
            type: type ? { id: type } : null,
            licencePlate: licencePlate === '' ? null : licencePlate,
            chassisNumber: chassisNumber === '' ? null : chassisNumber,
            numberOfSeats: numberOfSeats === '' ? null : numberOfSeats,
            productionYear: productionYear === '' ? null : productionYear,
            purchaseYear: purchaseYear === '' ? null : purchaseYear,
            status: status ? { id: status } : null,
            fuelType: fuelType ? { id: fuelType } : null,
        };

        if (this.state.requestMode === 'add') {
            axios.post('/assets/vehicle/', { ...vehicleRequest })
                .then(res => {
                    if (this.state.showFiltersOnButton) {
                        this.getFilteredVehicles(this.state.activePage - 1, this.state.resultsPerPage);
                    } else {
                        this.getVehicles(this.state.activePage - 1, this.state.resultsPerPage);
                    }
                    toast('Zahtjev uspješno poslan!');
                    this.resetValues(null);
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške prilikom dodavanja vozila!');
                });
        } else if (this.state.requestMode === 'edit') {
            const vehiclePutRequest = { ...vehicleRequest, id: vehicleId, optLock };
            axios.put('/assets/vehicle/', { ...vehiclePutRequest })
                .then(res => {
                    if (this.state.showFiltersOnButton) {
                        this.getFilteredVehicles(this.state.activePage - 1, this.state.resultsPerPage);
                    } else {
                        this.getVehicles(this.state.activePage - 1, this.state.resultsPerPage);
                    }
                    toast('Zahtjev uspješno poslan!');
                    this.resetValues(null);
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške prilikom uređivanja vozila!');
                });
        }
    }

    activateAddRequest() {
        this.resetValues('add');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    activateEditRequest(vehicle) {
        this.populateValues(vehicle);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    cancelRequest() {
        this.resetValues(null);
    }

    activateFilter() {
        this.setState({
            showFilterMode: !this.state.showFilterMode
        });
    }

    // TODO: Merge two setStates into one, figure out how
    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        this.getVehicles(0, this.state.resultsPerPage);
    }

    resetValues(requestMode) {
        const { activeRole } = this.state;
        this.setState(prevState => ({
            manufacturer: null,
            type: null,
            status: null,
            model: '',
            licencePlate: '',
            chassisNumber: '',
            numberOfSeats: '',
            purchaseYear: '',
            productionYear: '',
            fuelType: null,
            vehicleId: null,
            optLock: null,

            organizationalUnitError: false,
            typeError: false,
            chassisNumberError: false,
            licencePlateError: false,

            organizationalUnitId: checkOrganizationalUnitsPrivilege(activeRole) ? null : prevState.organizationalUnitId,
            requestMode,
        }));
    }

    populateValues(vehicle) {
        if (vehicle) {
            this.setState({
                organizationalUnitId: vehicle.organizationalUnit.id,
                manufacturer: vehicle.manufacturer ? vehicle.manufacturer.id : null,
                type: vehicle.type ? vehicle.type.id : null,
                status: vehicle.status ? vehicle.status.id : null,
                model: vehicle.model,
                licencePlate: vehicle.licencePlate,
                chassisNumber: vehicle.chassisNumber,
                numberOfSeats: vehicle.numberOfSeats,
                purchaseYear: vehicle.purchaseYear,
                productionYear: vehicle.productionYear,
                fuelType: vehicle.fuelType ? vehicle.fuelType.id : null,
                vehicleId: vehicle.id,
                optLock: vehicle.optLock,
                requestMode: 'edit',
                organizationalUnitError: false,
                typeError: false,
                chassisNumberError: false,
                licencePlateError: false,
            });
        } else {
            this.setState({ requestMode: null });
        }
    }

    switchToDetails(vehicle) {
        if (vehicle !== null) {
            this.setState({
                details: true,
                vehicleObject: vehicle,
            });
        }
    }

    switchToTable() {
        this.setState({
            organizationalUnitPropertyObject: null,
            details: false,
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleLicencePlateChange(event, { value }) {
        this.setState({
            licencePlate: value.toUpperCase()
        });
    }

    // NOTE: Should be implemented as soon as the archive process is specified
    deleteVehicle(vehicleId) {
        axios.delete(`/assets/vehicle/${vehicleId}`)
            .then(() => {
                toast('Uspješno arhivirano vozilo!');
                this.getVehicles(this.state.activePage - 1, this.state.resultsPerPage);
                this.resetValues(null);
            })
            .catch((err) => {
                toast('Nije uspjelo arhiviranje vozila!');
                console.log(err);
            });
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            this.getFilteredVehicles(activePage - 1, this.state.resultsPerPage);
        } else {
            this.getVehicles(activePage - 1, this.state.resultsPerPage);
        }
    }

    handleResultsPerPageChange(e, { value }) {
        if (this.state.showFiltersOnButton) {
            this.getFilteredVehicles(0, value);
            return;
        }

        this.getVehicles(0, value);
    }

    // NOTE: Couldn't extract the form and make another component VehicleForm, needs Redux for functionality
    render() {
        const {
            details,
            error,
            loading,
            activeRole
        } = this.state;
        const vehicles = this.getDataToRender();
        const writePrivilege = checkWritePrivilege(activeRole);
        const organizationalUnitsPrivilege = checkOrganizationalUnitsPrivilege(activeRole);
        if (error) return <div>Greška</div>;
        if (loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        if (details) {
            return (
                <VehicleDetails
                    vehicle={this.state.vehicleObject}
                    switchToTable={this.switchToTable}
                />
            );
        }
        return (
            <div>
                <Header as="h1"><FormattedMessage id="assets.vehicles.title" /></Header>
                <Transition.Group animation="slide up" duration={1000}>
                    {(this.state.requestMode !== null) &&
                    <Segment.Group raised>
                        <Segment raised>
                            <Header as="h3">
                                {this.state.requestMode === 'add' ? <FormattedMessage id="assets.vehicles.add" /> : <FormattedMessage id="assets.vehicles.edit" />}
                            </Header>
                        </Segment>
                        <Segment raised>
                            <Form noValidate>
                                <Header as="h3"><FormattedMessage id="assets.vehicles.about" /></Header>
                                {organizationalUnitsPrivilege &&
                                <Form.Group widths="4">
                                    <Form.Dropdown clearable
                                        label="Organizaciona jedinica"
                                        placeholder="Organizaciona jedinica"
                                        value={this.state.organizationalUnitId}
                                        onChange={this.handleInputChange}
                                        name="organizationalUnitId"
                                        options={this.state.organizationalUnits}
                                        search
                                        fluid
                                        selection
                                        required
                                        error={this.state.organizationalUnitError}
                                    />
                                </Form.Group>
                                }
                                <Form.Group widths="4">
                                    <Form.Dropdown clearable
                                        label="Proizvođač"
                                        placeholder="Proizvođač"
                                        value={this.state.manufacturer}
                                        onChange={this.handleInputChange}
                                        name="manufacturer"
                                        options={this.state.lookups.manufacturers}
                                        search
                                        selection
                                        fluid
                                    />
                                    <Form.Field
                                        label="Model"
                                        control={Input}
                                        name="model"
                                        value={this.state.model}
                                        onChange={this.handleInputChange}
                                        placeholder="Model"
                                    />
                                    <Form.Dropdown clearable
                                        label="Tip"
                                        placeholder="Tip"
                                        value={this.state.type}
                                        onChange={this.handleInputChange}
                                        name="type"
                                        options={this.state.lookups.types}
                                        search
                                        fluid
                                        selection
                                        required
                                        error={this.state.typeError}
                                    />
                                </Form.Group>
                                <Header as="h3">Specifikacije vozila</Header>
                                <Form.Group widths="4">
                                    <Form.Field
                                        type="text"
                                        label="Tablice"
                                        control={Input}
                                        name="licencePlate"
                                        value={this.state.licencePlate}
                                        onChange={this.handleLicencePlateChange}
                                        placeholder="Tablice"
                                        required
                                        error={this.state.licencePlateError}
                                    />
                                    <Form.Field
                                        type="text"
                                        label="Šasija"
                                        control={Input}
                                        name="chassisNumber"
                                        value={this.state.chassisNumber}
                                        onChange={this.handleInputChange}
                                        placeholder="Broj šasije"
                                        required
                                        error={this.state.chassisNumberError}
                                    />
                                    <Form.Field
                                        type="number"
                                        label="Broj sjedišta"
                                        control={Input}
                                        name="numberOfSeats"
                                        value={this.state.numberOfSeats}
                                        onChange={this.handleInputChange}
                                        placeholder="Broj sjedišta"
                                    />
                                </Form.Group>
                                <Form.Group widths="4">
                                    <Form.Field
                                        type="number"
                                        label="Godina proizvodnje"
                                        control={Input}
                                        name="productionYear"
                                        value={this.state.productionYear}
                                        onChange={this.handleInputChange}
                                        placeholder="Godina proizvodnje"
                                    />
                                    <Form.Field
                                        type="number"
                                        label="Godina nabavke"
                                        control={Input}
                                        name="purchaseYear"
                                        value={this.state.purchaseYear}
                                        onChange={this.handleInputChange}
                                        placeholder="Godina nabavke"
                                    />
                                    <Form.Dropdown clearable
                                        label="Status"
                                        placeholder="Status"
                                        value={this.state.status}
                                        onChange={this.handleInputChange}
                                        name="status"
                                        options={this.state.lookups.statuses}
                                        selection
                                        search
                                        fluid
                                    />
                                    <Form.Dropdown clearable
                                        label="Tip goriva"
                                        placeholder="Tip goriva"
                                        value={this.state.fuelType}
                                        onChange={this.handleInputChange}
                                        name="fuelType"
                                        options={this.state.lookups.fuelTypes}
                                        selection
                                        search
                                        fluid
                                    />
                                </Form.Group>
                                <Button
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.sendVehicleRequest();
                                        }
                                    }
                                >
                                    {this.state.requestMode === 'add' ? 'Pošalji' : 'Uredi'}
                                </Button>
                                <Button
                                    onClick={this.cancelRequest}
                                    basic
                                    color="blue"
                                >Odustani</Button>
                            </Form>
                        </Segment>
                    </Segment.Group>
                    }
                </Transition.Group>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Spisak vozila
                            <Header style={IconHeader} floated="right">
                                {this.state.showFiltersOnButton &&
                                <Button
                                    floated="left"
                                    icon
                                    labelPosition="right"
                                    color="orange"
                                    size="small"
                                    style={FiltersOnStyle}
                                >
                                    <Icon className="remove" onClick={this.filtersOff} />
                                    Filter uključen
                                </Button>}
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="filter" onClick={this.activateFilter} />}
                                    content="Filtriraj podatke"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    {this.state.showFilterMode &&
                    <VehicleFilter
                        onFilterData={this.onFilterData}
                        lookups={this.state.lookups}
                        organizationalUnits={this.state.organizationalUnits}
                        organizationalUnitsPrivilege={organizationalUnitsPrivilege}
                        cancelFilter={this.activateFilter}
                    />
                    }


                    <Segment>
                        {
                            writePrivilege &&
                            <React.Fragment>
                                <Button
                                    floated="left"
                                    icon
                                    labelPosition="left"
                                    primary
                                    size="medium"
                                    onClick={this.activateAddRequest}
                                >
                                    <Icon className="file text outline icon" />
                                        Dodavanje novog vozila
                                </Button>
                                <ResultsPerPageDropdown
                                    resultsPerPage={this.state.resultsPerPage}
                                    onResultsPerPageChange={this.handleResultsPerPageChange}
                                />
                                <br />
                                <br />
                            </React.Fragment>
                        }
                        {
                        // <Input
                        //     type="number"
                        //     float="right"
                        //     placeholder="Rezultati"
                        //     value={this.state.resultsPerPage}
                        //     onChange={this.handleInputChange}
                        //     name="resultsPerPage"
                        // />
                        }
                        {
                            vehicles && vehicles.length ?
                                <VehicleTable
                                    vehicles={vehicles}
                                    activateEditRequest={this.activateEditRequest}
                                    writePrivilege={writePrivilege}
                                    switchToDetails={this.switchToDetails}
                                    deleteVehicle={this.deleteVehicle}
                                    getSortedVehicles={this.getSortedVehicles}
                                    fieldName={this.state.fieldName}
                                    direction={this.state.direction}
                                /> :
                                <p>Nema podataka.</p>
                        }
                    </Segment>

                    <PaginationSegment
                        activePage={this.state.activePage}
                        totalPages={this.state.totalPages}
                        onPageChange={this.handlePageChange}
                    />
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}
export default Vehicles;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles.js